module.exports = __webpack_public_path__ + "static/media/Time to Mix Blue and Red and Make a Mauve.16d8f33e.jpg";